(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-bundle-offers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__scentOffersBound) return;
    window.__scentOffersBound = true;

    function label(btn, text) {
      var lbl = btn.querySelector('.scent-offers__add-label');
      if (lbl) lbl.textContent = text;
    }
    function addText(btn) {
      return btn.getAttribute('data-add-label') || 'Ajouter';
    }
    function removeText(btn) {
      return btn.getAttribute('data-remove-label') || 'Retirer';
    }
    function pickFromBtn(btn) {
      return {
        productId: parseInt(btn.getAttribute('data-product-id'), 10),
        variantId: parseInt(btn.getAttribute('data-variant-id'), 10),
        title: btn.getAttribute('data-title') || '',
        image: btn.getAttribute('data-image') || '',
        price: parseInt(btn.getAttribute('data-price'), 10) || 0,
        compareAt: parseInt(btn.getAttribute('data-compare'), 10) || 0,
        type: 'autre'
      };
    }

    /* Reflect whether each offer is currently in the bundle selection. */
    function syncButtons() {
      if (!(window.ScentBundle && window.ScentBundle.hasProduct)) return;
      document.querySelectorAll('[data-offer-add]').forEach(function (btn) {
        var inBundle = window.ScentBundle.hasProduct(btn.getAttribute('data-product-id'));
        btn.classList.toggle('is-added', inBundle);
        label(btn, inBundle ? removeText(btn) : addText(btn));
      });
    }

    /* ----- Cart fallback (used only if the bundle engine isn't on the page) ----- */
    function addToCart(variantId, btn) {
      var drawer = document.querySelector('cart-drawer');
      var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
      var body = {
        items: [{ id: variantId, quantity: 1 }],
        sections: sections.length ? sections : undefined,
        sections_url: window.location.pathname
      };
      var endpoint = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'Add to cart failed');
          if (drawer && res.data.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res.data);
          } else {
            window.location.href = '/cart';
            return;
          }
          btn.classList.add('is-added');
          label(btn, 'Ajouté ✓');
          setTimeout(function () { btn.classList.remove('is-added'); label(btn, addText(btn)); }, 1800);
        })
        .catch(function (err) {
          console.warn('[scent-offers] ' + (err && err.message ? err.message : err));
          label(btn, addText(btn));
        })
        .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-offer-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      // Preferred path: add to / remove from the bundle builder selection.
      if (window.ScentBundle && window.ScentBundle.toggleProduct) {
        var added = window.ScentBundle.toggleProduct(pickFromBtn(btn));
        btn.classList.toggle('is-added', added);
        label(btn, added ? removeText(btn) : addText(btn));
        return;
      }

      // Fallback: no bundle engine on the page — add straight to the cart.
      var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      label(btn, 'Ajout…');
      addToCart(variantId, btn);
    });

    // Keep the buttons in sync with the bundle on load and after engine boot.
    document.addEventListener('scent-bundle:ready', syncButtons);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncButtons);
    } else {
      syncButtons();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-faq"] && !Shopify.designMode) return;
  try {
    
  // Sliding open/close for <details>-based FAQ items.
  //
  // Why JS, not pure CSS: a closed <details> hides its non-summary
  // children (display: none equivalent), so a CSS height transition
  // never has anything to animate. We intercept the click, keep `open`
  // true while the height transitions, and only flip `open=false` once
  // the close animation finishes. This preserves SEO — the content sits
  // in the DOM at all times and search bots see the full answer markup
  // whether the section is open or closed.
  //
  // Hash deep-linking: a URL like /pages/faq#faq-<sectionId>-<blockId>
  // auto-opens the matching question and scrolls it into view, so a
  // direct link to a specific FAQ from search results lands the user
  // exactly where they expected.
  (function () {
    const DURATION = 360;
    const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(section) {
      if (section.dataset.faqInit === '1') return;
      section.dataset.faqInit = '1';

      const exclusive = section.dataset.faqExclusive === 'true';
      const items = Array.from(section.querySelectorAll('[data-faq-details]'));

      items.forEach((details) => {
        const summary = details.querySelector('summary');
        const wrap = details.querySelector('[data-faq-content]');
        if (!summary || !wrap) return;

        // ARIA: announce expand/collapse state to screen readers.
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          if (details.dataset.animating === '1') return;

          if (details.open) {
            close(details, wrap);
          } else {
            if (exclusive) {
              items.forEach((other) => {
                if (other !== details && other.open) {
                  const otherWrap = other.querySelector('[data-faq-content]');
                  if (otherWrap) close(other, otherWrap);
                }
              });
            }
            open(details, wrap);
          }
        });
      });
    }

    function open(details, wrap) {
      details.open = true;
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');

      if (reduceMotion) return;

      const target = wrap.scrollHeight;
      details.dataset.animating = '1';
      wrap.style.height = '0px';
      wrap.style.overflow = 'hidden';
      // Force layout so the transition kicks in.
      void wrap.offsetHeight;
      wrap.style.transition = 'height ' + DURATION + 'ms ' + EASING;
      wrap.style.height = target + 'px';

      onTransitionDone(wrap, () => {
        wrap.style.transition = '';
        wrap.style.height = '';
        wrap.style.overflow = '';
        details.dataset.animating = '0';
      });
    }

    function close(details, wrap) {
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');

      if (reduceMotion) {
        details.open = false;
        return;
      }

      // Snapshot current height before we change anything so the
      // transition has an explicit start value.
      const start = wrap.scrollHeight;
      details.dataset.animating = '1';
      wrap.style.height = start + 'px';
      wrap.style.overflow = 'hidden';
      void wrap.offsetHeight;
      wrap.style.transition = 'height ' + DURATION + 'ms ' + EASING;
      wrap.style.height = '0px';

      onTransitionDone(wrap, () => {
        // Flip the open state AFTER the animation so the browser
        // doesn't yank the content out of the DOM mid-transition.
        details.open = false;
        wrap.style.transition = '';
        wrap.style.height = '';
        wrap.style.overflow = '';
        details.dataset.animating = '0';
      });
    }

    function onTransitionDone(el, fn) {
      let called = false;
      const handler = (e) => {
        if (e.target !== el || e.propertyName !== 'height') return;
        if (called) return;
        called = true;
        el.removeEventListener('transitionend', handler);
        fn();
      };
      el.addEventListener('transitionend', handler);
      // Safety net in case `transitionend` doesn't fire (e.g. tab
      // backgrounded mid-animation).
      setTimeout(() => {
        if (called) return;
        called = true;
        el.removeEventListener('transitionend', handler);
        fn();
      }, DURATION + 80);
    }

    function openFromHash() {
      const hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      let target;
      try { target = document.querySelector(hash); } catch (e) { return; }
      if (!target || !target.matches('[data-faq-details]')) return;
      const wrap = target.querySelector('[data-faq-content]');
      if (!wrap) return;

      const section = target.closest('.scent-faq');
      if (section && section.dataset.faqExclusive === 'true') {
        section.querySelectorAll('[data-faq-details]').forEach((other) => {
          if (other !== target && other.open) {
            const otherWrap = other.querySelector('[data-faq-content]');
            if (otherWrap) close(other, otherWrap);
          }
        });
      }
      if (!target.open) open(target, wrap);
      setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'center' }), 60);
    }

    function bootAll() {
      document.querySelectorAll('.scent-faq[data-section-id]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    window.addEventListener('load', openFromHash);
    window.addEventListener('hashchange', openFromHash);

    // Re-init when Shopify's theme editor swaps the section in.
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.scent-faq[data-section-id]');
      if (section) init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
